import {RadioGroup} from '../RadioGroup';

export class MatrixSingleChoiceScale {
  constructor(question, scale, onChange) {
    this.question = question;
    this.id = scale.id;
    this.onChange = onChange;

    var rows = Array.from(this.question.domNode.querySelectorAll('[role="group"]'));
    this.radioGroups = rows.map((row) => {
      var radioDomNodes = Array.from(row.querySelectorAll('[role="radio"][data-scale-id="' + this.id + '"]'));
      return new RadioGroup(radioDomNodes, this.onChange);
    });
  }
}
